import { z } from 'zod'

import { JobCompanyDetailQuery } from '@/_gql/graphql'

export interface CompanyFormDto extends z.infer<typeof CompanyFormDto> {}
export const CompanyFormDto = z.object({
  name: z.string().min(1, 'Nama perusahaan tidak boleh kosong'),
  size_from: z.coerce.number({ message: 'Required' }),
  size_to: z.coerce.number({ message: 'Required' }),
  logo: z
    .instanceof(File, { message: 'Logo tidak boleh kosong' })
    .refine((file) => file.size > 0, {
      message: 'Logo tidak boleh kosong',
    })
    .or(z.string().min(1, 'Logo tidak boleh kosong')),
})

export function getDefaultValues(
  initial?: JobCompanyDetailQuery['getJobCompanyDetail']['data']
): CompanyFormDto {
  return {
    name: initial?.name || '',
    size_from: initial?.size_from || 0,
    size_to: initial?.size_to || 0,
    logo: initial?.logo || '',
  }
}
